


























import { Component, Vue, Prop } from "vue-property-decorator";
import ReferralStatusWiseCount from "./ReferralStatusWiseCount.vue";
import CandidateList from "./CandidateList.vue";
@Component({
  name: "ReferralCard",
  components: {
    ReferralStatusWiseCount,
    CandidateList,
  },
})
export default class ReferralCard extends Vue {
  @Prop() referral;
  @Prop() header;
  @Prop({ default: false }) friendReferral;

  get getId() {
    return this.referral.referralCode;
  }
}
